import { useDispatch, useSelector } from "react-redux";
import { identity } from "lodash";

import {
    selectCurrentExportTab,
    selectCurrentInvalidPreDefined,
} from "app/pages/sales-intelligence/sub-modules/management/store/selectors/common";
import type { ExportItem, PredefinedValueType } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import { setPreDefinedInvalidFields } from "app/pages/sales-intelligence/sub-modules/management/store/actions/common";

import { DataTypeMap } from "../constants";

export const usePreDefinedValidation = (
    settingItem: ExportItem,
): {
    validate(dataType: PredefinedValueType, value: string | undefined): boolean;
    allInvalidField: ExportItem[];
} => {
    const dispatch = useDispatch();

    const possibleTypes: Record<PredefinedValueType, (value?: string) => boolean> = {
        Boolean: (value: string) => {
            if (!value) {return false;}
            return "false" === value.toLowerCase() || "true" === value.toLowerCase();
        },
        Numeric: (value: string) => /^[0-9]+$/i.test(value),
        Picklist: (value: string) => value.trim() !== "",
        Text: identity,
        Date: identity,
        DateTime: identity,
        Reference: identity,
    };

    const currentTab = useSelector(selectCurrentExportTab);
    const allInvalidField = useSelector(selectCurrentInvalidPreDefined(currentTab));

    const validate = (dataType: PredefinedValueType, value?: string) => {
        if (DataTypeMap[dataType]) {
            const isValid = possibleTypes[dataType](value);

            const alreadyInvalid = allInvalidField.find((invalid) => {
                if (invalid.field === settingItem.field) {
                    return true;
                }

                return false;
            });

            if (!isValid && !alreadyInvalid) {
                dispatch(
                    setPreDefinedInvalidFields({
                        tabName: currentTab,
                        invalidFields: [...allInvalidField, settingItem],
                    }),
                );
            }

            if (isValid && alreadyInvalid) {
                const newInvalid = allInvalidField.filter((invalid) => {
                    if (invalid.field === settingItem.field) {
                        return false;
                    }

                    return true;
                });

                dispatch(
                    setPreDefinedInvalidFields({
                        tabName: currentTab,
                        invalidFields: [...newInvalid],
                    }),
                );
            }

            return isValid;
        }
        return false;
    };

    return { validate, allInvalidField };
};
